import { Injectable } from '@angular/core';
import { CommercialItemValidationResponse } from '../../models/commercial-item-validation-response.model';
import { MonographSalesCatalogue } from '../../models/monograph/monograph-sales-catalogue.model';
import { MonographValidationResponse } from '../../models/monograph/monograph-validation-response.model';

@Injectable({
    providedIn: 'root'
})
export class MonoGraphTestPlanningLineRule {

    constructor(private monoGraphSC: MonographSalesCatalogue) { }

    validateMonoGraphTest(testCode: string, monographCode: string, compendiumCode: string): CommercialItemValidationResponse {
        const monograph = this.monoGraphSC.monographs
            .filter(c => c.code === monographCode && c.compendium?.code === compendiumCode).shift();
        const monographItem = monograph?.monographItems.find(c => c.salesCatalogueItem.code === testCode);
        const test = monographItem?.salesCatalogueItem;
        const monoGraphTest: MonographValidationResponse = {};
        if (test) {
            const prepTestCodes = test.preparationTests?.map(c => c.code).concat(test.monographPreparationTests?.map(c => c.code));
            monoGraphTest.testCode = test.code;
            monoGraphTest.name = test.name;
            monoGraphTest.compendiumName = monograph.compendium?.name;
            monoGraphTest.monographName = monograph.name;
            monoGraphTest.compendiumCode = monograph.compendium?.code;
            monoGraphTest.monographCode = monograph.code;
            monoGraphTest.price = test.price;
            monoGraphTest.sortIndex = monographItem.orderNumber;
            monoGraphTest.preparationTests = prepTestCodes;
            monoGraphTest.salesCatalogCode = this.monoGraphSC.code;
        }
        return {
            data: monoGraphTest,
            isValid: test !== undefined,
        };
    }
}
